import { testimonials } from '@/mocks/categories';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-2 h-2 rounded-full bg-accent-500"></div>
            <span className="text-xs font-medium text-accent-600 uppercase tracking-widest">Verified Reviews</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            Real Buyers. Real Results.
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            Hear from sourcing professionals who use mulebuy spreadsheet tools every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl p-6 md:p-7">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm text-accent-500"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-5">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-sm font-semibold text-primary-700 flex-shrink-0">
                  {t.avatar}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}